<template>
  <div class="temp-container full-width">
    <v-col class="stepper-main">
      <v-row class="px-12 ma-0">
        <v-col class="pa-0 ma-0">
          <h2>Umfrage definieren</h2>
          <p class="text-gray text-description mb-2">Bitte geben Sie Ihrer Umfrage einen Namen und setzen Sie eine
            Startseite.</p>
        </v-col>
      </v-row>
      <v-row class="px-12 py-6 temp-content border-10">
        <v-col>
          <h3>Einstellungen der Umfrage</h3>
          <v-text-field :disabled="isResend" label="Umfragetitel" v-model="surveyDetails.title" style="width: 94%;"></v-text-field>
          <v-row>
            <flat-pickr :config="config"
                          id="datetime-input"
                          class="form-control mt-4"
                          v-model="dateVal"
                          placeholder="Deadline(optional)">
              </flat-pickr>
          </v-row>
          <v-switch
              v-if="!isIWAKQuestion"
              v-model="surveyDetails.customTitlePage"
              label="Benutzerdefinierte Startseite"
              class="mt-4"
          ></v-switch>
          <div class="callout-container mt-8">
            <v-row class="callout border-10 mt-2">
              <v-col cols="1" class="pl-6 mr-2">
                <v-icon color="primary">mdi-comment-alert</v-icon>
              </v-col>
              <v-col cols="10.5" class="pr-6 pl-4">
                <p class="text-gray text-description">
                  Hier können Sie eine benutzerdefinierte Startseite für Ihre Umfrage erstellen.
                </p>
                  <div class="text-gray text-description">Für eine Umfrage eignet sich ein persönliches Anschreiben
                    vorab. Um die
                    Rücklaufquote zu
                    erhöhen, können unter anderem folgende Punkte beachtet werden: <p></p>
                  <li>Text sollte Persönlich ansprechen</li>
                  <li>Ziel und Nutzen der Umfrage sollte Angesprochen werden</li>
                  <li>Zeitdauer der Umfrage sollte ganannt werden</li>
                  <li>Deadlines können bereits genannt werden</li>
                  <li>Info der Anonymisierung der Umfrage</li>
                  <li>Es sollte enthalten sein von wem die Umfrage kommt</li>
                  <li>Ansprechpartner sollte genannt sein</li>
                  </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-divider
            vertical
        ></v-divider>
        <v-col class="frontPageStyle pl-10">
          <div v-if="surveyDetails.customTitlePage">
            <h4>Startseite <span v-if="isIWAKQuestion">(mind. 20 Zeichen)</span></h4>
            <vue-editor :editorOptions="editorSettings" style="height:80%" v-model="surveyDetails.description"/>
          </div>
          <div v-else class="d-flex flex-column align-center align-self-center justify-content-center mt-10">
            <div class="svg-container mb-6">
              <svg width="87" height="83" viewBox="0 0 87 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="49.5" cy="47" rx="37.5" ry="36" fill="#EBEBEB"/>
                <g clip-path="url(#clip0_2362_15383)">
                  <path d="M41.0391 14.6H53.6291L41.0391 0.75V14.6Z" stroke="#A9A9A9" stroke-width="1.5" stroke-linejoin="round" stroke-dasharray="4 4"/>
                  <path d="M53.63 21.1V14.6L41.04 0.75H0.75V71.25H53.63V43.66" stroke="#A9A9A9" stroke-width="1.5" stroke-miterlimit="10" stroke-dasharray="6 6"/>
                  <path d="M4.5293 8.2998H37.2593" stroke="#A9A9A9" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M4.5293 15.8604H37.2593" stroke="#A9A9A9" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M4.5293 23.4102H49.8493" stroke="#A9A9A9" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M4.5293 30.96H42.2893" stroke="#A9A9A9" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M4.5293 53.6299H23.4093" stroke="#A9A9A9" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M4.5293 61.1797H23.4093" stroke="#A9A9A9" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M35.1695 57.8005L61.9995 31.0005C62.9395 30.0605 62.6795 28.2905 61.4295 27.0005L58.7995 24.4505C57.5495 23.2005 55.7995 22.9505 54.7995 23.8905L28.0495 50.6805L26.2695 59.5805L35.1695 57.8005Z" stroke="#A9A9A9" stroke-width="1.5" stroke-miterlimit="10"/>
                  <path d="M36.0605 49.7798L54.7605 31.0898" stroke="#A9A9A9" stroke-width="1.5" stroke-miterlimit="10"/>
                  <path d="M24.4902 61.3601L26.2702 59.5801" stroke="#A9A9A9" stroke-width="1.5" stroke-miterlimit="10"/>
                  <path d="M28.9395 49.7803H32.4995V53.3503H36.0595V56.9103" stroke="#A9A9A9" stroke-width="1.5" stroke-miterlimit="10"/>
                  <path d="M52.0898 26.6396L59.2098 33.7596" stroke="#A9A9A9" stroke-width="1.5" stroke-miterlimit="10"/>
                </g>
                <defs>
                  <clipPath id="clip0_2362_15383">
                    <rect width="63.28" height="72" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h4>Ohne Startseite</h4>
            <p class="text-description text-gray">Ihre Umfrage wird ohne Startseite versendet.</p>
            <v-btn text color="primary" @click="surveyDetails.customTitlePage = true"><v-icon>add</v-icon>
              Startseite
              hinzufügen</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <div class="temp-bottom">
      <v-row class="px-12 py-4 ma-0 d-flex flex-row bg-white justify-space">
        <v-col class="pa-0 d-flex justify-start">
          <v-btn v-if="currentStep !== 1" text @click.stop="goBack" color="secondary">
            <v-icon>mdi-chevron-left</v-icon> Zurück</v-btn>
        </v-col>
        <v-col v-if="selectedQuestions != null && selectedQuestions.length != 0" cols="9" class="text-right pa-0"><v-chip id="chip" color="primary"
                                                                                         class="mr-2">{{
            selectedQuestions.length }}</v-chip>Fragen wurden
          ausgewählt</v-col>
        <v-col class="pa-0 d-flex justify-end">
          <v-btn elevation="0" @click="previewSurvey()" color="secondary" :disabled="surveyDetails.title == '' || (isIWAKQuestion && surveyDetails.description.length < 25)">Weiter
            <v-icon>mdi-chevron-right</v-icon></v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";
import surveyGenerator from "@/components/px-survey-generator";
import moment from "moment";
import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
import { parseDate } from "vuetify/lib/components/VCalendar/util/timestamp";
import ImageResize from "quill-image-resize-vue";
import { ImageDrop } from "quill-image-drop-module";

Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/imageDrop", ImageDrop);
export default {
  props: [
      'surveyDetails',
      'selectedQuestions',
      'isIWAKQuestion',
      'currentStep'
  ],
  components:{
    VueEditor,
    flatPickr
  },
  name: "surveySetting",
  data() {
    return {
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {}
        }
      },
      inputText: "",
      title: null,
      description: "",
      customTitlePage: false,
      dateVal: null,
      config: {
        enableTime: true,
        dateFormat: 'd.m.Y H:i',
        minDate: new Date(),
        time_24hr: true, 
      },
      prevStep: '',
      nextStep: '',
    };
  },
  computed:{
    isResend(){
      return this.$route.params.isResend;
    }
  },
  mounted() {
    if(this.isIWAKQuestion) this.surveyDetails.customTitlePage = true;
    if(this.surveyDetails.deadlineDate != null) this.dateVal = this.surveyDetails.deadlineDate;
    this.prevStep = this.currentStep - 1;
    this.nextStep = this.currentStep + 1;
  },
  methods: {
    parseDate(val){
      const [dateValues, timeValues] = val.split(' ');
      const [day, month, year] = dateValues.split('.');
      const [hours, minutes] = timeValues.split(':');
      const result = new Date(year, month - 1, day, hours, minutes);
      return result;
    },
    previewSurvey() {
      if(this.dateVal != null) this.surveyDetails.deadlineDate = this.parseDate(this.dateVal);
      this.$emit('changeStep', this.nextStep);
    },
    goBack() {
      this.$emit('changeStep', this.prevStep);
    },
  }
};
</script>
<style scoped>
:deep .v-picker__body{
    width:500px !important;
}
.temp-content {
  height: calc(100% - 100px);
}
.form-control {
  width: 92%;
  margin-left: 12px;
}

.callout-container {
  width: 94%;
  height: calc(40vh - 10vmin);
  position: relative;
  margin-left: 12px;
}

.callout {
  width: 100%;
  height: 100%;
  position: absolute;
}

.callout::before {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  background: var(--v-primary-base);
  content: '';
  opacity: .06;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.callout .col {
  padding-top: 3vmin;
}
.frontPageStyle{
  max-width:50%
}
</style>